import React from 'react'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Model from './Model';

export default function Todos(props) {
  return (
    <>
      <tr>
          <th scope="row">{props.srno}</th>
          <td>{props.fname}</td>
          <td>{props.lname}</td>
          <td>{props.email}</td>
          <td className='iconedit'><EditIcon data-bs-toggle="modal" data-bs-target={`#modalData${props.id}`}/></td>
          <td className='icondelete'><DeleteIcon /></td>
      </tr>
      <Model id={`modalData${props.id}`}/>
    </>

  )
}
